import { useEffect, useState } from "react";
import {
  MOBILE_VIEWPORT_MEDIA_QUERY,
  PHONEISH_VIEWPORT_MEDIA_QUERY,
} from "../utils/viewportBreakpoints";

/**
 * True when the properties inspector should use the docked left sheet layout (touch phones /
 * small tablets), not when the viewport is merely narrow with a mouse (IDE preview pane).
 */
export function useInspectorMobileSheetLayout() {
  const [sheet, setSheet] = useState(() => computeInspectorMobileSheet());

  useEffect(() => {
    const onChange = () => setSheet(computeInspectorMobileSheet());
    const mqNarrow = window.matchMedia(MOBILE_VIEWPORT_MEDIA_QUERY);
    const mqPhone = window.matchMedia(PHONEISH_VIEWPORT_MEDIA_QUERY);
    let mqCoarse = null;
    try {
      mqCoarse = window.matchMedia("(pointer: coarse)");
    } catch {
      mqCoarse = null;
    }
    onChange();
    mqNarrow.addEventListener("change", onChange);
    mqPhone.addEventListener("change", onChange);
    if (mqCoarse) mqCoarse.addEventListener("change", onChange);
    return () => {
      mqNarrow.removeEventListener("change", onChange);
      mqPhone.removeEventListener("change", onChange);
      if (mqCoarse) mqCoarse.removeEventListener("change", onChange);
    };
  }, []);

  return sheet;
}

function computeInspectorMobileSheet() {
  if (typeof window === "undefined") return false;
  const narrow = window.matchMedia(MOBILE_VIEWPORT_MEDIA_QUERY).matches;
  if (!narrow) return false;
  const veryNarrow = window.matchMedia(PHONEISH_VIEWPORT_MEDIA_QUERY).matches;
  let coarse;
  try {
    coarse = window.matchMedia("(pointer: coarse)").matches;
  } catch {
    coarse = false;
  }
  return coarse || veryNarrow;
}
